import { useParams } from 'react-router-dom';
import DDP from 'components/widgets/ProjectDetails/DDP';
import PDP from 'components/widgets/ProjectDetails/PDP';
import { isDocumentViewQuery } from 'state/queryParams';

const ProjectDetailsPage = () => {
  const { id: projectSlug } = useParams();
  const [isDocumentView] = isDocumentViewQuery();

  if (isDocumentView) {
    return <DDP documentId={projectSlug as string} />;
  }

  return <PDP projectSlug={projectSlug as string} />;
};

export default ProjectDetailsPage;
